import React, { useEffect, useState } from 'react'

import { YSpacing } from '@components/common'
import { MarketDropdown, Input, Button } from '@components/common/form'

import { IndexHeadquarter } from '@types'

interface VendorPricingAgreementsReportsProps {
  getHeadquarters: () => Promise<IndexHeadquarter[]>
  generateVendorPricingAgreementsReport: (data: {
    hqIds: number[]
    email: string
  }) => Promise<boolean>
  displaySuccessMessage: (message: string) => void
}

const VendorPricingAgreementsReports: React.FC<
  VendorPricingAgreementsReportsProps
> = ({
  getHeadquarters,
  generateVendorPricingAgreementsReport,
  displaySuccessMessage,
}) => {
  const [headquarters, setHeadquarters] = useState<IndexHeadquarter[]>([])
  const [selectedHeadquarters, setSelectedHeadquarters] = useState<number[]>([])
  const [email, setEmail] = useState<string>('')

  useEffect(() => {
    const loadHeadquarters = async () => {
      const headquarters = await getHeadquarters()
      setHeadquarters(headquarters)
    }
    loadHeadquarters()
  }, [getHeadquarters])

  const onSelectHq = (hqId: number) => {
    setSelectedHeadquarters([...selectedHeadquarters, hqId])
  }

  const onDeselectHq = (hqId: number) => {
    setSelectedHeadquarters(selectedHeadquarters.filter((id) => id !== hqId))
  }

  const onGenerateReport = async () => {
    const result = await generateVendorPricingAgreementsReport({
      hqIds: selectedHeadquarters,
      email,
    })
    if (result) {
      displaySuccessMessage('Reports generated successfully')
    }
  }

  return (
    <div>
      <MarketDropdown
        label="Market(s)"
        options={headquarters}
        selectedOptions={selectedHeadquarters}
        onSelectHq={onSelectHq}
        onDeselectHq={onDeselectHq}
      />
      {selectedHeadquarters.length > 0 && (
        <>
          <YSpacing height="20px" />
          <Input
            label="Email"
            placeholder="reports@tryhungry.com"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            }
          />
        </>
      )}
      {selectedHeadquarters.length > 0 && email.length > 0 && (
        <div className="flex justify-items-center w-full mt-5">
          <Button label="Generate Reports" onClick={onGenerateReport} />
        </div>
      )}
    </div>
  )
}

export default VendorPricingAgreementsReports
